import { Component, Input, input, ChangeDetectionStrategy } from '@angular/core';
import { MatLabel } from '@angular/material/form-field';
//import { JkBaseComponent } from '../jkbase/jkbase.component';

@Component({
  selector: 'app-jkfieldlabel',
  standalone: true,
  imports: [MatLabel],
  templateUrl: './jkfieldlabel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './jkfieldlabel.component.scss'
})
export class JkfieldlabelComponent { //extends JkBaseComponent{
  comType: string = 'jkfieldlabel';
  readonly required = input<boolean>(false);
  readonly displayLabel = input<boolean>(true);
  //@Input() labelMode: LabelMode = 'floating'; // = 'floating';
  _label: string = '';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set label(value: string) {
    this._label = value;
  }
  get label(): string {
    return this._label;
  }
  /**
   * @property {string} emojiLabel
   * @description 顯示在輸入欄位左側的 Emoji。
   */
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() emojiLabel = '';

}
